module.exports = __webpack_public_path__ + "static/media/back.cbac64c3.svg";